var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsersGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 16.666C14.1667 15.2853 12.3012 14.166 10 14.166C7.69881 14.166 5.83333 15.2853 5.83333 16.666M17.5 14.1659C17.5 13.1408 16.4716 12.2597 15 11.8739M2.5 14.1659C2.5 13.1408 3.52841 12.2597 5 11.8739M15 8.52944C15.5115 8.07167 15.8333 7.40643 15.8333 6.66602C15.8333 5.2853 14.714 4.16602 13.3333 4.16602C12.693 4.16602 12.109 4.40673 11.6667 4.80259M5 8.52944C4.48854 8.07167 4.16667 7.40643 4.16667 6.66602C4.16667 5.2853 5.28595 4.16602 6.66667 4.16602C7.30696 4.16602 7.89104 4.40673 8.33333 4.80259M10 11.666C8.61929 11.666 7.5 10.5467 7.5 9.16602C7.5 7.7853 8.61929 6.66602 10 6.66602C11.3807 6.66602 12.5 7.7853 12.5 9.16602C12.5 10.5467 11.3807 11.666 10 11.666Z",
    stroke: "#F7FAFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersGroup);
export default __webpack_public_path__ + "static/media/Users_Group.dea299d4a6d50bd65cb184604fa3913a.svg";
export { ForwardRef as ReactComponent };